import { render, staticRenderFns } from "./BotaoHomologarAdjudicarItemLote.vue?vue&type=template&id=710e8c26&scoped=true"
import script from "./BotaoHomologarAdjudicarItemLote.vue?vue&type=script&lang=js"
export * from "./BotaoHomologarAdjudicarItemLote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710e8c26",
  null
  
)

export default component.exports